/**
 * Route for `branding`. Registered via createRoute; root wires into router.tsx.
 *
 * router.tsx imports `BrandingPage` as a value from this module and mounts it
 * via a plain component factory — so we must re-export the page component here
 * in addition to emitting the TanStack route object.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { BrandingPage } from "../features/branding/BrandingPage";

export { BrandingPage };

export const brandingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/branding",
	component: BrandingPage,
});

export default brandingRoute;
